import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library
import { devConfig } from 'config/config'; // Importing development configuration from the config module

/**
 * Class representing a view for table incomes.
 * @extends JetView
 */
export default class tableIncomesView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format for displaying dates in the datatable
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Set the height based on screen width
            height: screen.width < 500 ? 400 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing entries
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip for the edit icon
                    tooltip: _('Editar'),
                    // Template for the edit icon
                    template: function(obj) {
                        return '<span class=\'webix_icon wxi-close edit\'></span>';
                    },
                },
                // Column for ID with sorting enabled
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                {
                    // Column for description with localization
                    id: 'Description',
                    header: _('Descripción'),
                    width: 150,
                    sort: 'int',
                },
                {
                    // Column for creation date with localization and date formatting
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat,
                },
                {
                    // Column for income type with localization
                    id: 'TypeIncomes',
                    header: _('Tipo de Ingreso'),
                    width: 150,
                    sort: 'int',
                },
                {
                    // Column for document ID with localization
                    id: 'DocumentID',
                    header: _('Documento ID'),
                    width: 150,
                    sort: 'int',
                },
                {
                    // Column for concept with localization
                    id: 'Concept',
                    header: _('Concepto'),
                    width: 150,
                    sort: 'int',
                },
                // Column for value with localization
                { id: 'Value', header: _('Valor'), width: 150, sort: 'int' },
                // Column for VAT with localization
                { id: 'Iva', header: _('IVA'), width: 150, sort: 'int' },
                {
                    // Column for retraction with localization
                    id: 'Retraccion',
                    header: _('Retracción'),
                    width: 150,
                    sort: 'int',
                },
            ],
            // Define click event for the edit icon
            onClick: {
                edit: function(euv, id) {
                    // Show the edit form when the edit icon is clicked
                    $$('EditIncomes').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching configuration
            loadahead: devConfig.getDefaultDataFetch(),
            // Define the pager for pagination
            pager: 'pagerA',
            // Set the URL for fetching data from the API
            url: devConfig.geturlApi() + 'BetShop/GetIncomes?FromId=' + cur_user + '&',
            // Sample data for the datatable
            data: [
                {
                    Id: '01',
                    IsBetShop: 0,
                    CreatedLocalDate: '2019-02-03',
                    Description: 'Compra',
                    TypeIncomes: 'Tipo Ingreso 1',
                    DocumentID: '1010',
                    Value: '100',
                    Iva: '10',
                    Retraccion: '10',
                    Concept: 'Concepto 1',
                },
                {
                    Id: '02',
                    IsBetShop: 1,
                    Description: 'Servicio',
                    CreatedLocalDate: '2019-02-03',
                    TypeIncomes: 'Tipo Ingreso 2',
                    DocumentID: '1010',
                    Value: '1',
                    Iva: '10',
                    Retraccion: '10',
                    Concept: 'Concepto 2',
                },
            ],
            // Define double-click event for items in the datatable
            on: {
                onItemDblClick: (id) => {
                    // Show the edit form on double-click
                    $$('EditIncomes').show();
                },
            },
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        /**
         * Retrieves localization service and initializes variables for the grid and popup configuration.
         */
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for grid data
        const cur_user = this.getParam('user', true); // Current user parameter
        var filter = ''; // Filter string for data fetching
        var datePopup3 = []; // Array to store concepts data
        var datePopup4 = []; // Array to store types of center position data
        var popupAdd = ''; // Popup configuration
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Current date in formatted string

        /**
         * Fetches concepts data for the popup form.
         */
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Sets content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function(text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Displays error message on failure
                },
                success: function(text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses the response
                    datePopup3 = resp.Data; // Stores concepts data

                    /**
                     * Fetches types of center position data for the popup form.
                     */
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Sets content type for the request
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', '{"Type":2}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Displays error message on failure
                            },
                            success: function(text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parses the response
                                datePopup4 = resp.Data; // Stores types of center position data

                                /**
                                 * Configures and initializes the popup for adding incomes.
                                 */
                                popupAdd = webix.ui({
                                    view: 'window', // Popup window
                                    width: 750, // Width of the popup
                                    id: 'AddIncomes', // Unique ID for the popup
                                    head: {
                                        view: 'toolbar', // Toolbar for the popup header
                                        cols: [
                                            {
                                                view: 'label', // Label for the popup title
                                                label: _('Añadir Gasto'),
                                            },
                                            {
                                                view: 'icon', // Close icon
                                                icon: 'wxi-close',
                                                click: function() {
                                                    this.getTopParentView().hide(); // Hides the popup on click
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Centers the popup
                                    modal: true, // Enables modal behavior
                                    body: {
                                        view: 'form', // Form inside the popup
                                        id: 'addform', // Unique ID for the form
                                        elements: [
                                            {
                                                margin: 10, // Margin for the form elements
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for description
                                                        label: _('Descripción'),
                                                        name: 'Description',
                                                        labelWidth: 140,
                                                        required: true, // Marks the field as required
                                                    },
                                                    {
                                                        view: 'text', // Text input for creation date
                                                        label: _('Fecha de Creación'),
                                                        labelWidth: 140,
                                                        name: 'CreatedLocalDate',
                                                        value: createdLocalDate, // Pre-filled with the current date
                                                        readonly: true, // Read-only field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for income type
                                                        label: _('Tipo de Ingreso'),
                                                        name: 'TypeIncomes',
                                                        labelWidth: 140,
                                                        options: datePopup4, // Options fetched from the server
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for concept
                                                        label: _('Concepto'),
                                                        name: 'Concept',
                                                        labelWidth: 140,
                                                        options: datePopup3, // Options fetched from the server
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for document ID
                                                        label: _('Documento ID'),
                                                        name: 'DocumentID',
                                                        labelWidth: 140,
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for value
                                                        label: _('Valor'),
                                                        name: 'Value',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for IVA
                                                        label: _('IVA'),
                                                        name: 'Iva',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for retraction
                                                        label: _('Retracción'),
                                                        name: 'Retraccion',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button
                                                        value: _('Cancelar'),
                                                        click: function() {
                                                            this.getTopParentView().hide(); // Hides the popup
                                                            $$('addform').setValues($$('addform').getCleanValues()); // Resets the form
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button
                                                        type: 'form',
                                                        value: _('Guardar'),
                                                        click: function($e) {
                                                            var values = $$('addform').getValues(); // Retrieves form values
                                                            if ($$('addform').validate()) {
                                                                // Validates the form
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Sets content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() + 'BetShop/Incomes', // API endpoint
                                                                        '{"Description":"' +
                                                                        values.Description +
                                                                        '", "CreatedLocalDate":"' +
                                                                        values.CreatedLocalDate +
                                                                        '", "TypeIncomes":"' +
                                                                        values.TypeIncomes +
                                                                        '"  , "BetShop":"' +
                                                                        cur_user +
                                                                        '" , "Concept":"' +
                                                                        values.Concept +
                                                                        '" , "DocumentID":"' +
                                                                        values.DocumentID +
                                                                        '"  , "Value":"' +
                                                                        values.Value +
                                                                        '", "Iva":"' +
                                                                        values.Iva +
                                                                        '", "Retraccion":"' +
                                                                        values.Retraccion +
                                                                        '"}',
                                                                        {
                                                                            error: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! ')); // Displays error message
                                                                            },
                                                                            success: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Gasto Agregado')); // Success message
                                                                                grid.clearAll(); // Clears the grid
                                                                                grid.load(
                                                                                    url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter, // Reloads the grid
                                                                                );
                                                                                // Additional logic for displaying a PDF (omitted for brevity)
                                                                                webix
                                                                                    .ui({
                                                                                        view: 'window',
                                                                                        width: 500,
                                                                                        height: 700,
                                                                                        head: {
                                                                                            view: 'toolbar',
                                                                                            cols: [
                                                                                                {
                                                                                                    view: 'label',
                                                                                                    label: _('Factura'),
                                                                                                },
                                                                                                {
                                                                                                    view: 'button',
                                                                                                    label: 'X',
                                                                                                    width: 100,
                                                                                                    align: 'right',
                                                                                                    click: '$(\'windowfact2\').close();',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                        id: 'windowfact2',
                                                                                        modal: true,
                                                                                        position: 'center',
                                                                                        body: {
                                                                                            rows: [
                                                                                                {
                                                                                                    template:
                                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                    })
                                                                                    .show();
                                                                                var reader = new FileReader();
                                                                                reader.onload = function(event) {
                                                                                    $$('pdf').clear();
                                                                                    $$('pdf').parse({
                                                                                        data: event.target.result,
                                                                                    });
                                                                                };

                                                                                function b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                    sliceSize,
                                                                                ) {
                                                                                    contentType = contentType || '';
                                                                                    sliceSize = sliceSize || 512;
                                                                                    var byteCharacters = atob(b64Data);
                                                                                    var byteArrays = [];
                                                                                    for (
                                                                                        var offset = 0;
                                                                                        offset < byteCharacters.length;
                                                                                        offset += sliceSize
                                                                                    ) {
                                                                                        var slice =
                                                                                            byteCharacters.slice(
                                                                                                offset,
                                                                                                offset + sliceSize,
                                                                                            );
                                                                                        var byteNumbers = new Array(
                                                                                            slice.length,
                                                                                        );
                                                                                        for (
                                                                                            var i = 0;
                                                                                            i < slice.length;
                                                                                            i++
                                                                                        ) {
                                                                                            byteNumbers[i] =
                                                                                                slice.charCodeAt(i);
                                                                                        }
                                                                                        var byteArray = new Uint8Array(
                                                                                            byteNumbers,
                                                                                        );
                                                                                        byteArrays.push(byteArray);
                                                                                    }
                                                                                    var blob = new Blob(byteArrays, {
                                                                                        type: contentType,
                                                                                    });
                                                                                    return blob;
                                                                                }

                                                                                var contentType = 'application/pdf';
                                                                                var b64Data = data.Pdf;
                                                                                var blob = b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                );
                                                                                var file =
                                                                                    window.URL.createObjectURL(blob);
                                                                                console.log(blob);
                                                                                document.querySelector('iframe').src =
                                                                                    file;
                                                                                var printWindow = window.open(
                                                                                    file,
                                                                                    '',
                                                                                    'width=800,height=500',
                                                                                );
                                                                                printWindow.print();
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addform').setValues($$('addform').getCleanValues()); // Resets the form
                                                                this.getTopParentView().hide(); // Hides the popup
                                                            } else {
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _('Completa los campos...'), // Validation error message
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function() {
                                                    this.validate(); // Validates the form on change
                                                },
                                            },
                                        },
                                    },
                                });
                            },
                        });
                },
            });

        // Listen for the 'incomes:filter' event on the app instance
        this.on(this.app, 'incomes:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize an empty string to build the query parameters

            // Iterate through each key-value pair in the object
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split the date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to the query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to the query string
                    } else {
                        // Handle the 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split the date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to the query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to the query string
                        } else {
                            // Add other filters to the query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert the nested object to an array
                        // Iterate through each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle the 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object from the value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format the date
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to the query string
                                } else {
                                    // Handle the 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object from the value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format the date
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to the query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append the current user ID to the query string
            grid.clearAll(); // Clear the existing grid data
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string for future reference
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Set the starting point and count for pagination
                filter + // Include any additional filters
                '&sort[' +
                by + // Specify the field to sort by
                ']=' +
                dir, // Specify the direction of sorting (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item using its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected PlayerId
            grid.load(
                grid.data.url +
                '?start=0&count=' +
                grid.data.$pagesize + // Set the starting point and count for pagination
                '&PlayerId=' +
                Id, // Include the selected PlayerId as a filter
            );
        });
        // Create a popup window for editing income entries
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            width: 750, // Set the width of the window
            id: 'EditIncomes', // Unique identifier for the window
            head: {
                // Header configuration for the window
                view: 'toolbar', // Define the header as a toolbar
                cols: [
                    // Columns within the toolbar
                    { view: 'label', label: _('Editar Gasto') }, // Label for the window title
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function() {
                            // Click event handler
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                // Body configuration of the window
                view: 'form', // Define the body as a form
                id: 'editForm', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within this element
                            {
                                view: 'text', // Text input for ID
                                label: 'ID', // Label for the input
                                name: 'Id', // Name attribute for the input
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Description
                                label: _('Descripción'), // Label for the input
                                name: 'Description', // Name attribute for the input
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within this element
                            {
                                view: 'text', // Text input for Created Local Date
                                label: _('Fecha de Creación'), // Label for the input
                                labelWidth: 140, // Width of the label
                                name: 'CreatedLocalDate', // Name attribute for the input
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Type of Income
                                label: _('Tipo de Ingreso'), // Label for the input
                                name: 'TypeIncomes', // Name attribute for the input
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within this element
                            {
                                view: 'text', // Text input for Document ID
                                label: _('Documento ID'), // Label for the input
                                name: 'DocumentID', // Name attribute for the input
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within this element
                            {
                                view: 'combo', // Combo box for Concept
                                label: _('Concepto'), // Label for the input
                                name: 'Concept', // Name attribute for the input
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Value
                                label: _('Valor'), // Label for the input
                                name: 'Value', // Name attribute for the input
                                type: 'number', // Input type as number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within this element
                            {
                                view: 'text', // Text input for IVA
                                label: _('IVA'), // Label for the input
                                name: 'Iva', // Name attribute for the input
                                type: 'number', // Input type as number
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Retraction
                                label: _('Retracción'), // Label for the input
                                name: 'Retraccion', // Name attribute for the input
                                type: 'number', // Input type as number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        cols: [
                            // Columns for action buttons
                            {
                                view: 'button', // Button for Cancel action
                                value: _('Cancelar'), // Button label
                                click: function() {
                                    // Click event handler
                                    this.getTopParentView().hide(); // Hide the window
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for Save action
                                type: 'form', // Button type as form submission
                                value: _('Guardar'), // Button label
                                click: function($e) {
                                    // Click event handler
                                    var values =$$('editForm').getValues(); // Get form values
                                    webix // Perform an AJAX request
                                        .ajax()
                                        .headers({
                                            // Set request headers
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            // Send POST request
                                            devConfig.geturlApi() + // API URL
                                            'BetShop/Incomes',
                                            '{"Id":"' + // JSON payload
                                            values.Id +
                                            '", "IsBetShop":"' +
                                            values.IsBetShop +
                                            '", "Description":"' +
                                            values.Description +
                                            '", "CreatedLocalDate":"' +
                                            values.CreatedLocalDate +
                                            '", "TypeIncomes":"' +
                                            values.TypeIncomes +
                                            '"  , "BetShop":"' +
                                            cur_user +
                                            '"  , "DocumentID":"' +
                                            values.DocumentID +
                                            '"  , "Value":"' +
                                            values.Value +
                                            '", "Iva":"' +
                                            values.Iva +
                                            '", "Retraccion":"' +
                                            values.Retraccion +
                                            '"}',
                                            {
                                                error: function(
                                                    // Error callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function(
                                                    // Success callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Gasto Actualizado')); // Show success message
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload grid data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Event listener for the 'AddIncome:button' event on the application instance
        this.on(this.app, 'AddIncome:button', (filter) => {
            // Clears any validation messages on the 'addform' component
            $$('addform').clearValidation();
            // Displays the popup for adding income
            popupAdd.show();
        });
        // Binds the 'editForm' component to the 'datatable' component for data synchronization
       $$('editForm').bind($$('datatable')); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
